export const insuranceSortOrder = ['cost_asc', 'cost_desc', 'added'] as const;
export type InsuranceSortOrder = (typeof insuranceSortOrder)[number];
